<script setup>
import { computed, onMounted } from 'vue';
import GuestLayout from '@/Layouts/GuestLayout.vue';
import AppLayout from '@/Layouts/AppLayout.vue';
import { usePage } from '@inertiajs/vue3';

const props = defineProps({
    title: String
});

const page = usePage();

const user = computed(() => page.props.auth?.user);

// onMounted(() => {
//   console.log('Component mounted');
//   console.log('Page props:', page.props);
//   console.log('User from page props:', user.value);
// });

const LayoutComponent = computed(() => {
    // console.log('Computing LayoutComponent');
    // console.log('User:', user.value);
    return user.value ? AppLayout : GuestLayout;
});
</script>

<template>

    <component :is="LayoutComponent">
        <br /><br />
        <div class="font-sans antialiased">
            <div class="pt-4 bg-gray-100">
                <div class="flex flex-col items-center min-h-screen pt-6 pb-8 sm:pt-0">
                    <div
                        class="w-full p-6 mt-6 text-gray-900 bg-white border border-gray-400 rounded-lg shadow-xl sm:max-w-4xl">
                        <h1 class="mb-4 text-3xl font-bold text-center">{{ title }}</h1>
                        <!-- <p v-if="user">Logged in as: {{ user.name }}</p>
            <p v-else>Not logged in</p> -->
                        <slot />
                    </div>
                </div>
            </div>
        </div>
    </component>
</template>
